import Button from "../../../../../publicComponent/Button";
import {useTranslation} from "react-i18next";
import {useDelCollect, useSaveCollect} from "../../../../../api/prodItemCollect";
import {useQueryParam} from "../../../../../hooks";
import {useGoodsDetailContext} from "../../index";
import useRequestTokenAuth from "../../../../../hooks/useRequestTokenAuth";
import useNotice from "../../../../../hooks/useNotice";
import {useRef, useState} from "react";

export default function AddWishButton({ className, detail = {}, noText }) {
  const { t } = useTranslation();
  const { loading, addWishHandle } = useSaveCollect();
  const { delWishHandle } = useDelCollect();
  const [goodsId] = useQueryParam('goodsId');
  const { state } = useGoodsDetailContext();
  const [auth] = useRequestTokenAuth();
  const [isCollect, setIsCollect] = useState(detail.isCollect);
  const notice = useNotice();
  
  const addWish = async () => {
    if (!goodsId) return notice.warn('商品Id不存在，请检查URL');
    
    let q = {
      collectId: goodsId,
      sourceId: goodsId,
      collectType: 1,
      itemInfo: detail,
    };
    
    await auth(null, q);
    
    let { data } = await addWishHandle(q);
    
    if (data) {
      notice.success(t('已添加到心愿单'));
      setIsCollect('1');
    }
  };
  
  const delWish = async () => {
    if (!goodsId) return notice.warn('商品Id不存在，请检查URL');
    
    let { data } = await delWishHandle({ sourceId: goodsId });
    
    if (data) {
      setIsCollect('0');
    }
  };
  
  const wishHandle = () => {
    console.log(detail);
    if (isCollect === '0') {
      addWish();
    } else {
      delWish();
    }
  };
  
  return (
    <Button className={`${className}`}
            // loading={loading}
            onClick={wishHandle}>
      {
        isCollect === '1'
          ? <i className="iconfont icon-favorite text-[20px] text-[#e30707] inline-block"/>
          : <i className="iconfont icon-favoriteoutline text-[20px] inline-block"/>
      }
      {
        !noText ?
          <>
            <span className="ml-[5px] mdmax:hidden">{t('加入心愿单')}</span>
            <span className="ml-[5px] md:hidden">{t('心愿')}</span>
          </>
          : null
      }
    
    </Button>
  );
}
